function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.69351 18.622H10.5V17.9444H1.69351C1.13235 17.9444 0.677389 17.4895 0.677389 16.9283V2.02506C0.677389 1.46372 1.13235 1.00893 1.69351 1.00893H16.5968C17.1582 1.00893 17.6129 1.46372 17.6129 2.02506V9.81532H18.2904V2.02506C18.2893 1.09018 17.5317 0.332647 16.5968 0.331543H1.69351C0.758805 0.332647 0.00118855 1.09018 0 2.02506V16.9283C0.00118855 17.8632 0.758805 18.6207 1.69351 18.622Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.35547 1.68649H2.03277V2.3638H1.35547V1.68649Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.70898 1.68649H3.38654V2.3638H2.70898V1.68649Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.06445 1.68649H4.74193V2.3638H4.06445V1.68649Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.35547 3.04123H16.936V3.71879H1.35547V3.04123Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.84024 4.49521L3.9799 5.35555C3.25268 4.8741 2.27883 5.02182 1.72692 5.69726C1.17509 6.37261 1.22459 7.35639 1.84127 7.97299C2.45788 8.58985 3.44174 8.63934 4.11718 8.08743C4.79253 7.5356 4.94033 6.56159 4.4588 5.83454L5.31906 4.97419L4.84024 4.49521ZM3.04731 7.78299C2.48623 7.78299 2.03127 7.32812 2.03127 6.76695C2.03127 6.2057 2.48623 5.75091 3.04731 5.75091C3.19843 5.75142 3.34708 5.78606 3.48266 5.85236L2.80799 6.52712L3.28681 7.00611L3.96199 6.33177C4.02829 6.46727 4.06301 6.61592 4.06352 6.76695C4.06352 7.32812 3.60873 7.78299 3.04731 7.78299Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.75781 5.75079H11.5157V6.4281H5.75781V5.75079Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.75781 7.10562H8.12872V7.78293H5.75781V7.10562Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.80664 7.10562H13.5485V7.78293H8.80664V7.10562Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1934 5.75079H15.5805V6.4281H12.1934V5.75079Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.84024 8.55963L3.9799 9.41997C3.25268 8.93852 2.27883 9.08624 1.72692 9.76168C1.17509 10.4371 1.22459 11.4208 1.84127 12.0376C2.45788 12.6543 3.44174 12.7038 4.11718 12.1519C4.79253 11.5999 4.94033 10.6263 4.4588 9.89896L5.31906 9.03862L4.84024 8.55963ZM3.04731 11.8475C2.48623 11.8475 2.03127 11.3925 2.03127 10.8314C2.03127 10.2701 2.48623 9.81516 3.04731 9.81516C3.19843 9.81576 3.34708 9.85048 3.48266 9.91679L2.80799 10.5917L3.28681 11.0705L3.96199 10.3961C4.02829 10.5317 4.06301 10.6803 4.06352 10.8314C4.06352 11.3925 3.60873 11.8475 3.04731 11.8475Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.75781 9.81531H11.5157V10.4928H5.75781V9.81531Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.75781 11.1703H8.12872V11.8477H5.75781V11.1703Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.80664 11.1703H11.5162V11.8477H8.80664V11.1703Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1934 9.81531H13.5481V10.4928H12.1934V9.81531Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.84024 12.6244L3.9799 13.4848C3.25268 13.0033 2.27883 13.151 1.72692 13.8265C1.17509 14.5019 1.22459 15.4856 1.84127 16.1024C2.45788 16.7191 3.44174 16.7685 4.11718 16.2166C4.79253 15.6647 4.94033 14.691 4.4588 13.9637L5.31906 13.1034L4.84024 12.6244ZM3.04731 15.9123C2.48623 15.9123 2.03127 15.4573 2.03127 14.8962C2.03127 14.3349 2.48623 13.88 3.04731 13.88C3.19843 13.8805 3.34708 13.9152 3.48266 13.9816L2.80799 14.6565L3.28681 15.1353L3.96199 14.4609C4.02829 14.5965 4.06301 14.7452 4.06352 14.8962C4.06352 15.4573 3.60873 15.9123 3.04731 15.9123Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.75781 13.8799H10.161V14.5575H5.75781V13.8799Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.75781 15.2349H8.12872V15.9123H5.75781V15.2349Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.80664 15.2349H10.1614V15.9123H8.80664V15.2349Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9186 20.6542C18.7247 20.6542 20.9992 18.3793 20.9992 15.5734C20.9992 12.7674 18.7247 10.4927 15.9186 10.4927C13.1125 10.4927 10.8379 12.7674 10.8379 15.5734C10.8412 18.378 13.1139 20.6508 15.9186 20.6542ZM15.9186 11.1702C18.3503 11.1702 20.3218 13.1416 20.3218 15.5734C20.3218 18.0053 18.3503 19.9766 15.9186 19.9766C13.4867 19.9766 11.5152 18.0053 11.5152 15.5734C11.5181 13.1428 13.4878 11.1729 15.9186 11.1702Z",
  fill: "#CED2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.8524 15.7606L13.2461 16.0633L13.9236 17.4182C13.9721 17.5157 14.0648 17.5838 14.1724 17.6012C14.1899 17.604 14.2074 17.6054 14.225 17.6056C14.3147 17.6056 14.4009 17.5699 14.4645 17.5064L18.5289 13.4419L18.05 12.9629L14.3177 16.6951L13.8524 15.7606Z",
  fill: "#CED2E3"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 21,
  fill: "white"
})));

var SvgTasksIcon = function SvgTasksIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTasksIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tasks-icon.c0e6063e.svg";
export { ForwardRef as ReactComponent };